import { AppStoreConfig } from '@ddt-web/data-service';

export const ModelsBrowseStoreConfig: AppStoreConfig = {
	families: { name: 'families', storeAsList: true },
	familyHoldings: { name: 'familyHoldings', storeAsList: true, defaultLoaded: true },
	familyOverview: { name: 'familyOverview', storeAsList: true, defaultLoaded: true },
	familyPerformance: { name: 'familyPerformance', storeAsList: true, defaultLoaded: true },
	reportConfig: { name: 'reportConfig', storeAsList: false, defaultValue: null, portfolioIndependent: true },
	applicationState: { name: 'applicationState', storeAsList: true, portfolioIndependent: true },
	filterConfig: { name: 'filterConfig', storeAsList: true },
	positionDetails: { name: 'positionDetails', storeAsList: true },
	familyEsg: { name: 'familyEsg', storeAsList: true, defaultLoaded: true }
};
